import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  DEALER_HOME,
  DEALER_BILLING,
  DEALER_BILLING_ACCOUNTING,
  DEALER_PAYMENTS,
  MODELS,
  MODELS_FORM_VEHICLE_TYPES,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Dealer",
    meta: { requiresAuth: true },
    redirect: { name: "DealerDetail" },
    component: () => import("@/modules/Dealer/Dealer"),
    children: [
      // DASHBOARD
      {
        path: "home",
        name: "Dealer Home",
        component: () => import("@/modules/Dealer/Pages/Index.vue"),
        meta: {
          code: MODULE.DEALER.DASHBOARD
        },
      },
      // DEALER
      {
        path: "list",
        name: "Owner Dealer List",
        component: () => import("@/modules/Owners/Pages/Owners/OwnerList"),
        meta: {
          code: MODULE.DEALER.DEALER
        },
      },
      {
        path: "detail/:ownerId?",
        name: "DealerDetail",
        component: () =>
          import("@/modules/Owners/Pages/Owners/Detail/OwnerDetailWrapper.vue"),
        meta: {
          code: MODULE.DEALER.DEALER
        },
        children: [
          {
            path: "information",
            name: "Dealer Details Information",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailInformation.vue"
              ),
            meta: {
              code: MODULE.DEALER.DEALER
            },
          },
          {
            path: "pricing",
            name: "Dealer Details Pricing",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailPricing.vue"
              ),
            meta: {
              code: MODULE.DEALER.DEALER
            },
          },
          {
            path: "personalization",
            name: "Dealer Details Personalization",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailPersonalization.vue"
              ),
            meta: {
              code: MODULE.DEALER.DEALER
            },
          },
          {
            path: "contracts",
            name: "Dealer Details Contracts",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailContracts.vue"
              ),
            meta: {
              code: MODULE.DEALER.DEALER
            },
          },
          {
            path: "hierarchy",
            name: "Dealer Detail Hierarchy",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailHierarchy"
              ),
            meta: {
              breadcrumb: [],
              notAllowed: [
                "SUPER_ADMIN",
                "EMPLOYEE",
                "TECHNICIAN",
                "SUPPORT",
                "EXTERNAL_SUPPORT",
              ],
            },
          },
        ],
      },
      // BILLING
      {
        path: "billing",
        name: "DealerBilling",
        component: () => import("@/modules/Owners/Pages/Billing/BillingIndex"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: DEALER_HOME },
            { name: "common.billing", link: DEALER_BILLING },
          ],
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/period/:period",
        name: "DealerOwnersBilling",
        component: () => import("@/modules/Owners/Pages/Billing/OwnersBilling"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/period/:period/:idOwner",
        name: "DealerOwnerBilling",
        component: () =>
          import("@/modules/Owners/Pages/Billing/OwnerBilling.vue"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/period/:period/:idOwner/:idVehicle/year/:year",
        name: "DealerVehicleBillingYear",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-year.vue"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/period/:period/:idOwner/:idVehicle/month/:month/:year",
        name: "DealerVehicleBillingMonth",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-month.vue"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path:
          "billing/period/:period/:idOwner/:idVehicle/day/:day/:month/:year",
        name: "DealerVehicleBillingDay",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-day.vue"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/accounting",
        name: "DealerAccounting",
        component: () =>
          import("@/modules/Owners/Pages/Billing/BillingAccounting.vue"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: DEALER_HOME },
            { name: "common.billing", link: DEALER_BILLING },
            { name: "common.payments", link: DEALER_PAYMENTS },
          ],
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/accounting/:year/:month/:idOrder",
        name: "DealerAccountingMonth",
        component: () =>
          import("@/modules/Owners/Pages/Billing/TransactionProcess.vue"),
        meta: {
          code: MODULE.DEALER.BILLING
        },
      },
      {
        path: "billing/payments",
        name: "DealerPayments",
        component: () =>
          import("@/modules/Owners/Pages/Billing/Payments.vue"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: DEALER_HOME },
            { name: "common.billing", link: DEALER_BILLING },
            { name: "common.accounting", link: DEALER_BILLING_ACCOUNTING },
          ],
          code: MODULE.DEALER.BILLING
        },
      },
      // SUBSCRIPTIONS
      {
        path: "subscriptions",
        name: "SubscriptionList",
        component: () =>
          import("@/modules/Dealer/Pages/Subscriptions/SubscriptionList.vue"),
        meta: {
          code: MODULE.DEALER.SUBSCRIPTIONS
        },
      },
      {
        path: "subscriptions/form",
        name: "SubscriptionForm",
        component: () =>
          import("@/modules/Dealer/Pages/Subscriptions/SubscriptionForm.vue"),
        meta: {
          breadcrumb: [
          ],
          code: MODULE.DEALER.SUBSCRIPTIONS
        },
      },
      {
        path: "subscriptions/detail/:id",
        name: "SubscriptionsDetail",
        component: () =>
          import(
            "@/modules/Dealer/Pages/Subscriptions/Detail/SubscriptionDetail.vue"
          ),
        meta: {
          breadcrumb: [],
          notAllowed: ["EMPLOYEE", "TECHNICIAN", "SUPPORT", "EXTERNAL_SUPPORT"],
          ownerTypeAllowed: ["OnlyDealer"],
        },
        redirect: { name: "SubscriptionsDetailDetail" },
        children: [
          {
            path: "detail",
            name: "SubscriptionsDetailDetail",
            component: () =>
              import(
                "@/modules/Dealer/Pages/Subscriptions/Detail/SubscriptionDetailsDetail.vue"
              ),
            meta: {
              code: MODULE.DEALER.SUBSCRIPTIONS
            },
          },
          {
            path: "vehicles",
            name: "SubscriptionsDetailVehicles",
            // FALTA DESCOMENTAR CUANDO ESTÉ DISPONIBLE PARA HACER LO DE VEHÍCULOS
            component: () =>
              import(
                "@/modules/Dealer/Pages/Subscriptions/Detail/SubscriptionDetailsVehicles.vue"
              ),
            meta: {
              code: MODULE.DEALER.SUBSCRIPTIONS
            },
          },
        ],
      },
      // MODELS
      {
        path: "models",
        name: "ModelList",
        component: () => import("@/modules/Dealer/Pages/Models/ModelList.vue"),
        meta: {
          breadcrumb: [],
          code: MODULE.DEALER.MODELS
        },
      },
      {
        path: "models/form",
        name: "ModelForm",
        component: () => import("@/modules/Dealer/Pages/Models/ModelForm.vue"),
        meta: {
          code: MODULE.DEALER.MODELS
        },
        redirect: { name: "ModelFormTypes" },
        children: [
          {
            path: "types",
            name: "ModelFormTypes",
            component: () =>
              import("@/modules/Dealer/Pages/Models/VehicleTypes.vue"),
            meta: {
              breadcrumb: [
                { name: "common.models", link: MODELS },
                {
                  name: "common.type",
                  link: MODELS_FORM_VEHICLE_TYPES,
                },
              ],
              code: MODULE.DEALER.MODELS
            },
          },
          {
            path: "types/:type",
            name: "ModelFormFields",
            component: () =>
              import("@/modules/Dealer/Pages/Models/ModelFormFields.vue"),
            meta: {
              code: MODULE.DEALER.MODELS
            },
          },
        ],
      },
      {
        path: "models/detail/:id",
        name: "ModelsDetail",
        component: () =>
          import("@/modules/Dealer/Pages/Models/ModelDetail.vue"),
        meta: {
          code: MODULE.DEALER.MODELS
        },
      },
      // DEVICES
      {
        path: "devices",
        name: "DeviceList",
        component: () =>
          import("@/modules/Dealer/Pages/Devices/DeviceList.vue"),
        meta: {
          code: MODULE.DEALER.DEVICES
        },
      },
      {
        path: "devices/form",
        name: "DeviceForm",
        component: () =>
          import("@/modules/Dealer/Pages/Devices/DeviceForm.vue"),
        meta: {
          breadcrumb: [
          ],
          code: MODULE.DEALER.DEVICES
        },
      },
      {
        path: "devices/detail/:id",
        name: "DeviceDetail",
        component: () => import("@/modules/Dealer/Pages/Devices/DeviceDetail"),
        meta: {
          code: MODULE.DEALER.DEVICES
        },
      },
      // VEHICLES
      {
        path: "vehicles",
        name: "DealerVehicleList",
        component: () =>
          import("@/modules/Dealer/Pages/Vehicles/VehicleList.vue"),
        meta: {
          code: MODULE.DEALER.VEHICLES
        },
      },
      {
        path: "vehicles/form",
        name: "VehicleFormModels",
        component: () => import("@/modules/Dealer/Pages/Models/ModelList.vue"),
        meta: {
          breadcrumb: [
          ],
          code: MODULE.DEALER.VEHICLES
        },
      },
      {
        path: "vehicles/form/:idModel",
        name: "VehicleForm",
        component: () =>
          import("@/modules/Dealer/Pages/Vehicles/VehicleForm.vue"),
        meta: {
          code: MODULE.DEALER.VEHICLES
        },
      },
      {
        path: "vehicles/detail/:id",
        name: "VehicleDetailWrapper",
        component: () =>
          import(
            "@/modules/Dealer/Pages/Vehicles/Detail/VehicleDetailWrapper.vue"
          ),
        meta: {
          code: MODULE.DEALER.VEHICLES
        },
        redirect: { name: "VehicleDetailsSubscription" },
        children: [
          {
            path: "subscription",
            name: "VehicleDetailsSubscription",
            component: () =>
              import(
                "@/modules/Dealer/Pages/Vehicles/Detail/VehicleDetailsSubscription.vue"
              ),
            meta: {
              code: MODULE.DEALER.VEHICLES
            },
          },
          {
            path: "conectivity",
            name: "VehicleDetailsConectivity",
            component: () =>
              import(
                "@/modules/Dealer/Pages/Vehicles/Detail/VehicleDetailsConectivity.vue"
              ),
            meta: {
              code: MODULE.DEALER.VEHICLES
            },
          },
          {
            path: "detail",
            name: "VehicleDetailsDetail",
            component: () =>
              import(
                "@/modules/Dealer/Pages/Vehicles/Detail/VehicleDetailsInformation.vue"
              ),
            meta: {
              code: MODULE.DEALER.VEHICLES
            },
          },
        ],
      },
      // CUSTOMERS
      {
        path: "customers",
        name: "CustomerList",
        component: () =>
          import("@/modules/Dealer/Pages/Customers/CustomerList.vue"),
        meta: {
          code: MODULE.DEALER.CUSTOMERS
        },
      },
      {
        path: "customers/form",
        name: "CustomerForm",
        component: () =>
          import("@/modules/Dealer/Pages/Customers/CustomerForm.vue"),
        meta: {
          code: MODULE.DEALER.CUSTOMERS
        },
      },
      {
        path: "customers/customer/:idCustomer/detail",
        name: "CustomerDetail",
        component: () =>
          import("@/modules/Dealer/Pages/Customers/CustomerDetail.vue"),
        meta: {
          code: MODULE.DEALER.CUSTOMERS
        },
      },
      {
        path: "customers/tag/:idTag",
        name: "CustomerDetailTag",
        component: () =>
          import("@/modules/Dealer/Pages/Customers/CustomerList.vue"),
        meta: {
          code: MODULE.DEALER.CUSTOMERS
        },
      },
    ],
  },
];